import { useGoalDeadlineRows as _useGoalDeadlineRows } from '@griply/hooks';
import { FilterDocument, Goal } from '@griply/types';
import { createGoalTreeIndex } from '@griply/utils';
import { useFilterDocumentFilters } from 'features/tasks';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { LifeArea } from 'shared/types/life-area';

export type UseGoalDeadlineRowsOptions = {
  goals: Goal[];
  lifeAreas: LifeArea[];
  filterDocument?: FilterDocument;
  showCompleted?: boolean;
  enabled?: boolean;
};

export const useGoalDeadlineRows = ({
  goals,
  lifeAreas,
  filterDocument,
  showCompleted,
  enabled,
}: UseGoalDeadlineRowsOptions) => {
  const taskCounts = useTaskCounts();
  const links = useEntityLinks();

  // The date sections supply the window, so the document's `or` branches drop out.
  const goalFilterDocument = useMemo<FilterDocument>(
    () => ({ ...filterDocument, or: null }),
    [filterDocument],
  );
  const filters = useFilterDocumentFilters(goalFilterDocument, {});

  const goalTreeIndex = useMemo(
    () => createGoalTreeIndex(goals, { links }),
    [goals, links],
  );

  return _useGoalDeadlineRows({
    goals,
    lifeAreas,
    filters,
    goalProgressCounts: taskCounts?.byGoalProgress,
    goalTreeIndex,
    showCompleted,
    enabled,
  });
};
